import { Col, Row, Card, Spin } from "antd";
import { useEffect, useState } from "react";
import ChartFilter from "../../../Common/ChartFilter";
import BoxplotChart from "./BoxplotChart";
import TimeSeriesChart from "./TimeSeriesChart";
import VEHICLE from "../../../../assets/images/icons/outline-vehicle.png";

const vehicleIcon = <img src={VEHICLE} alt="#" className="vehicle-loader" />;

const FullGraphsModal = ({ grafanaDetails, chartList }) => {
  const [chartType, setChartType] = useState({
    timeSeries: true,
    boxPlot: false,
  });

  useEffect(() => {
    setChartType({ timeSeries: true, boxPlot: false });
  }, [grafanaDetails]);

  const updateChartType = (name, value) => {
    setChartType((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Row className="deviation-monitor-box grafana-compare">
      <Col span={24}>
        <Card
          title={
            <Row justify="end">
              <Col span={4}>
                <ChartFilter
                  updateChartType={updateChartType}
                  chartType={chartType}
                  chartToHide={"histogram"}
                />
              </Col>
            </Row>
          }
        >
          <Spin
            indicator={vehicleIcon}
            spinning={!grafanaDetails?.timeSeries}
            size="large"
          >
            {chartList.map((chart, index) => (
              <Row key={index} gutter={[10, 16]} className="mt05">
                {chartType?.timeSeries ? (
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={chartType?.boxPlot ? 16 : 24}
                    id={"timeSeries-" + chart.toLowerCase()}
                  >
                    <TimeSeriesChart data={grafanaDetails?.timeSeries} />
                  </Col>
                ) : null}
                {chartType?.boxPlot ? (
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={chartType?.timeSeries ? 8 : 12}
                    id={"boxPlot-" + chart.toLowerCase()}
                  >
                    <BoxplotChart data={grafanaDetails?.boxPlotData} />
                  </Col>
                ) : null}
              </Row>
            ))}
          </Spin>
        </Card>
      </Col>
    </Row>
  );
};

export default FullGraphsModal;
